var map = {
	"./dictionary_ency/Credits.js": [
		626,
		0
	],
	"./dictionary_ency/Footer.js": [
		630,
		1
	],
	"./dictionary_ency/Header.js": [
		627,
		2
	],
	"./dictionary_ency/credit_contents/ChiSiamoBody.js": [
		1317,
		8
	],
	"./dictionary_ency/credit_contents/CreditsBody.js": [
		1318,
		9
	],
	"./dictionary_micura_glossari/Footer.js": [
		628,
		3
	],
	"./dictionary_micura_glossari/Header.js": [
		629,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1168;
module.exports = webpackAsyncContext;